import React, { useState } from "react";
import styles from "./History.module.scss";
import { Spin } from "@douyinfe/semi-ui";
import { useMessageStore } from "@/app/store";
import { getHistory } from "@/app/api/message";
import Locale from "@/app/locales";

export default function History() {
  const [loading, setLoading] = useState(false);
  const { lastHistoryMsg, insertHistory, setLastHistoryMsg } =
    useMessageStore();
  const getMoreHistory = async () => {
    if (!lastHistoryMsg.hasMore || loading) {
      return;
    }
    setLoading(true);
    const result = await getHistory({
      cursor: lastHistoryMsg.nextCursor,
      limit: 20,
    });
    setLastHistoryMsg({
      hasMore: result.hasMore,
      nextCursor: result.nextCursor,
    });
    insertHistory(result.records);
    setLoading(false);
  };
  const getLabel = () => {
    return lastHistoryMsg.hasMore
      ? Locale.chat.moreHistory
      : Locale.chat.noMoreHistory;
  };
  return (
    <span
      className={`${styles.moreHistory} ${lastHistoryMsg.hasMore ? "" : styles.noMore}`}
      onClick={getMoreHistory}
    >
      {loading ? <Spin size="small" /> : getLabel()}
    </span>
  );
}
